/* src/components/library-mgmt/delete-library-item-modal/delete-item-modal.component.scss */
.extra-description {
  margin-top: 1rem;
}
/*# sourceMappingURL=delete-item-modal.component-IX5J3BFE.css.map */
